/**
 * Which surface raised a mandatory two-factor enrollment gate. Drives both the
 * friendly, context-specific copy and whether the gate is hard (non-dismissable)
 * in the shared two-factor gate dialog, and lets each trigger point declare its
 * context without duplicating user-facing strings.
 *
 * - TREASURY_LOGIN: verified-Treasury org login gate — hard, dashboard withheld
 *   until enrolled. Also covers spend cardholders (they exist only in such orgs).
 * - TREASURY_KYC: pre-Treasury org launching Connect KYC — fires before
 *   verification begins; dismissable so the user can back out of setup.
 */
export enum TwoFactorGateReason
{
    TREASURY_LOGIN = 'treasuryLogin',
    TREASURY_KYC = 'treasuryKyc',
}
